import styled from "styled-components";
import * as antd from "antd";

export const SaveButton = styled((props) => (
  <antd.Button type="primary" {...props} />
))`
  background: linear-gradient(#fff, #fff) padding-box,
    linear-gradient(
        42.69deg,
        #fff33b -5.54%,
        #fee72e -1.35%,
        #fed51b 6.72%,
        #fdca10 15%,
        #fdc70c 23.9%,
        #f3903f 64.56%,
        #ed683c 87.51%,
        #e93e3a 99.24%
      )
      border-box;
  color: #313149;
  font-size: 18px;
  line-height: 18px;
`;
